export const DogChaserIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <title>{"dog-jump"}</title>
      <path
        d="M1.8,9.118C3.3,8.618,8.187,7.5,10.687,6.5a40.6,40.6,0,0,0,5-2.5l1.5-2a5.473,5.473,0,0,1,1,2c1.5,0,2,2,2,2l1.321.264a1,1,0,0,1,.733,1.352l-.252.63a.994.994,0,0,1-1.051.621A8.937,8.937,0,0,0,17.687,9a6.813,6.813,0,0,0-3,1.5s3.5-.5,4.5,1c.785,1.177,1,2,0,2.5-1.612.806-3-1-3-1s-3.514,1.172-4.677-.627h0S7.187,13,5.687,14A2.8,2.8,0,0,1,4.68,17.541L2.492,19.157A32.313,32.313,0,0,1,1.8,9.118Z"
        fill="#00e6ca"
      />
      <path
        d="M19.74,4.987A1.858,1.858,0,0,0,18.187,4a5.473,5.473,0,0,0-1-2l-1.5,2a40.6,40.6,0,0,1-5,2.5C8.187,7.5,3.3,8.618,1.8,9.118c-.089.891-.123,1.8-.124,2.719C12.4,9.229,16.365,5.166,19.74,4.987Z"
        fill="#c4f0eb"
      />
      <path
        d="M11.51,12.373a2.284,2.284,0,0,1-.323-.873"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.8,9.118C3.3,8.618,8.187,7.5,10.687,6.5a40.6,40.6,0,0,0,5-2.5l1.5-2a5.473,5.473,0,0,1,1,2c1.5,0,2,2,2,2l1.321.264a1,1,0,0,1,.733,1.352l-.252.63a.994.994,0,0,1-1.051.621A8.937,8.937,0,0,0,17.687,9a6.813,6.813,0,0,0-3,1.5s3.5-.5,4.5,1c.785,1.177,1,2,0,2.5-1.612.806-3-1-3-1s-3.514,1.172-4.677-.627h0S7.187,13,5.687,14A2.8,2.8,0,0,1,4.68,17.541"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.044,5.5c-.55-2.436-1.4-4-2.357-4-1.657,0-3,4.7-3,10.5s1.343,10.5,3,10.5c1.359,0,2.631-2.663,3-7"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.937,5.5a.25.25,0,0,0-.25.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.187,5.75a.25.25,0,0,0-.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.937,6a.25.25,0,0,0,.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.687,5.75a.25.25,0,0,0,.25.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
